// @ts-nocheck -- Legacy JavaScript compatibility boundary; runtime behavior intentionally preserved.
import { useState } from "react";
import { useTheme } from "@mui/material/styles";
import useTranslation from "next-translate/useTranslation";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { Info } from "@mui/icons-material";
import { Typography, Button } from "@/components/core";
import { Grid } from "@/components/core/grid";
import CreateEuropeanAccountDialog from "./dialog";

/**
 * @param {{
 * sx: import("@mui/material").SxProps<import("@mui/material").Theme>
 * }}
 */
export function CreateEuropeAccountCard() {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation("common");
  const theme = useTheme();

  const handleConfirm = () => {
    // TODO
  };

  return (
    <Grid>
      <Button
        variant="text"
        sx={{
          fontWeight: "bold",
          color: theme.palette.text.contrast,
          display: "flex",
          justifyContent: "space-between",
          minWidth: "100%",
        }}
        onClick={() => setOpen(true)}
      >
        <Typography sx={{ display: "flex", alignItems: "center" }}>
          <AddCircleIcon />
          {t("europeanAccountOpen")}
        </Typography>
        <Typography sx={{ display: "flex", alignItems: "center" }}>
          {t("europeanAccount")}
          <Info />
        </Typography>
      </Button>
      <CreateEuropeanAccountDialog open={open} setOpen={setOpen} handleConfirm={handleConfirm} />
    </Grid>
  );
}
